import React, { useCallback } from "react";
import { Stack, Typography } from "@mui/material";
import TimePickerCustom from "./index";

interface ITimeRangePicker {
  value: Array<any>;
  onChange: Array<(value: any, keyboardInputValue?: string) => void>;
  label?: React.ReactNode;
  required?: Array<boolean | undefined>;
  helperText?: Array<React.ReactNode>;
  error?: Array<boolean>;
  onBlur?: Array<Function>;
  onAccept?: Array<(value: any) => void>;
}

const TimeRangePicker = ({
  value,
  onChange,
  label,
  required,
  helperText,
  error,
  onBlur,
  onAccept,
}: ITimeRangePicker) => {
  const getValue = useCallback(
    (i: number) =>
      value.length > i ? (value[i].length > 0 ? value[i] : null) : null,
    [value],
  );
  const handleOnChange = useCallback(
    (i) => (v: any, k: any) =>
      onChange.length > i ? onChange[i](v, k) : () => { },
    [onChange],
  );
  const getRequired = useCallback(
    (i: number) => (required && required.length > i ? required[i] : undefined),
    [required],
  );
  const getHelperText = useCallback(
    (i: number) =>
      helperText && helperText.length > i ? helperText[i] : undefined,
    [helperText],
  );
  const getError = useCallback(
    (i: number) => (error && error.length > i ? error[i] : undefined),
    [error],
  );
  const handleOnBlur = useCallback(
    (i) => (onBlur && onBlur.length > i ? () => onBlur[i]() : undefined),
    [onBlur],
  );
  const handleOnAccept = useCallback(
    (i) => (v: any) =>
      onAccept && onAccept.length > i ? onAccept[i](v) : () => { },
    [onAccept],
  );

  return (
    <Stack direction={{ xs: "column", md: "row" }} spacing={0}>
      <TimePickerCustom
        value={getValue(0)}
        onChange={handleOnChange(0)}
        required={getRequired(0)}
        helperText={getHelperText(0)}
        error={getError(0)}
        onBlur={handleOnBlur(0)}
        onAccept={handleOnAccept(0)}
        label={label}
      />
      <Typography
        variant="h4"
        sx={{
          marginX: 2,
          mt: label ? 4 : 1,
          alignSelf: "flex-start",
          display: { xs: "none", md: "inline-flex" },
        }}
      >
        ~
      </Typography>
      <TimePickerCustom
        value={getValue(1)}
        onChange={handleOnChange(1)}
        required={getRequired(1)}
        helperText={getHelperText(1)}
        error={getError(1)}
        onBlur={handleOnBlur(1)}
        onAccept={handleOnAccept(1)}
        label={label ? "　" : undefined}
      />
    </Stack>
  );
};

export default TimeRangePicker;
